<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>部门
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree
              @clickByOrg="loadPlanLineList"
              @completed="initOrgTree"
            ></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-quyu el-icon--left"></i>设备巡检查看
          </div>
          <div class="es-op-box">
            <el-input
              placeholder="请输入系统名称"
              v-model="queryObj.sysName"
              size="small"
              class="query"
              style="float: left"
              clearable
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadPlanLineList(selectorgId);
                }
              "
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-input
              placeholder="请输入设备名称"
              v-model="queryObj.assetName"
              size="small"
              class="query"
              style="float: left"
              clearable
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadPlanLineList();
                }
              "
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select
              style="float: left"
              class="query"
              size="small"
              v-model="queryObj.typeId"
              placeholder="请选择设备类型"
              clearable
              filterable
              @clear="
                () => {
                  this.queryObj.pageNum = 1;
                  delete this.queryObj.typeId;
                  loadPlanLineList();
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadPlanLineList();
                }
              "
            >
              <el-option
                v-for="item in types"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <el-table
            :data="pageData.list"
            ref="lineTable"
            border
            stripe
            size="mini"
            height="calc(100vh - 250px)"
            style="top: 10px"
            v-loading="loading"
          >
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column prop="plandate" label="生成时间">
              <template slot-scope="scope">
                {{ scope.row.plandate.substring(0, 10) }}
              </template>
            </el-table-column> -->
            <el-table-column prop="sysName" label="系统名称">
              <template slot-scope="scope">
                {{ scope.row.sysName }}
                <el-image
                  v-for="(item, i) in showImgs(scope.row, scope.$index)"
                  :key="i"
                  style="
                    width: 20px;
                    height: 20px;
                    margin-left: 4px;
                    position: relative;
                    top: 5px;
                    border-radius: 4px;
                  "
                  :src="item"
                  :preview-src-list="areaImg[scope.row.areaId + '_id']"
                >
                </el-image>
                <el-button
                  v-if="showVideo(scope.row, scope.$index) != null"
                  icon="el-icon-caret-right"
                  size="mini"
                  style="margin-left: 4px"
                  circle
                  @click="play(scope.row.areaId)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="typeName" label="设备类型">
            </el-table-column>
            <el-table-column prop="assetName" label="设备名称">
            </el-table-column>
            <el-table-column prop="totalCount" label="巡检项数量">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <el-table
                    :data="insItemList"
                    border
                    height="calc(100vh - 500px)"
                    size="mini"
                  >
                    <el-table-column
                      prop="label"
                      label="巡检项名称"
                      width="150px"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="value"
                      label="巡检结果"
                      width="150px"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="finishTime"
                      label="巡检完成时间"
                      width="150px"
                    >
                    </el-table-column>
                  </el-table>
                  <a
                    slot="reference"
                    @mouseenter="findInsAssetPlanItem(scope.row)"
                    >{{ scope.row.totalCount }}</a
                  >
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="inspeopleName" label="巡检人">
            </el-table-column>
            <el-table-column prop="companionName" label="陪同人">
            </el-table-column>
            <el-table-column prop="finishTime" label="巡检时间">
            </el-table-column>
            <el-table-column prop="type" label="类型" width="70" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="showType(scope.row)">{{
                  scope.row.typename
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="never"
              label="频率"
              width="70"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="state"
              width="70"
              label="状态"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag size="mini" :type="showState(scope.row)">{{
                  scope.row.statename
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="faultcode"
              label="故障状态"
              width="70"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  v-if="
                    scope.row.faultCode == null || scope.row.faultCode == ''
                  "
                  slot="reference"
                  size="mini"
                  type="success"
                  >正常</el-tag
                >

                <el-popover v-else placement="top" trigger="hover">
                  <p>&nbsp;&nbsp;故障编码</p>
                  <div style="text-align: center; margin: 10">
                    <el-link
                      v-for="(item, index) in scope.row.faultCodelist"
                      :key="index"
                      @click="viewFaultInfo(item)"
                      icon="el-icon-warning"
                      type="danger"
                      >{{ item }}&nbsp;
                    </el-link>
                    <br />
                    <br />
                  </div>
                  <el-tag slot="reference" size="mini" type="danger"
                    >故障</el-tag
                  >
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60" align="center">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  title="详情"
                  @click="showDevicePlan(scope.row)"
                  type="primary"
                  ><i class="el-icon-font el-icon-view"></i
                ></el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination
              :data="pageData"
              @change="
                (cpage) => {
                  this.queryObj.pageNum = cpage;
                  this.loadPlanLineList();
                }
              "
            >
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--查看巡检设备详情-->
    <el-dialog
      :visible.sync="detailVisible"
      @closed="() => this.$refs['detailForm'].clearValidate()"
      width="1200px"
    >
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i
        >查看巡检设备详情
      </span>

      <el-table
        style="margin-top: 10px"
        :data="devicePlanPageData.list"
        ref="itemTable"
        border
        highlight-current-row
        stripe
        size="mini"
        height="65vh"
        v-loading="loadingdevice"
      >
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column prop="assetName" label="设备名称">
          <template slot-scope="scope">
            {{ scope.row.assetName }}
            <el-image
              v-for="(item, i) in showImgs(scope.row, scope.$index)"
              :key="i"
              style="
                width: 20px;
                height: 20px;
                margin-left: 4px;
                position: relative;
                top: 5px;
                border-radius: 4px;
              "
              :src="item"
              :preview-src-list="areaImg[scope.row.areaId + '_id']"
            >
            </el-image>
            <el-button
              v-if="showVideo(scope.row, scope.$index) != null"
              icon="el-icon-caret-right"
              size="mini"
              style="margin-left: 4px"
              circle
              @click="play(scope.row.areaId)"
            ></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="totalCount" label="巡检项数量">
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover">
              <el-table
                :data="insItemList"
                border
                height="calc(100vh - 500px)"
                size="mini"
              >
                <el-table-column prop="label" label="巡检项名称" width="150px">
                </el-table-column>
                <el-table-column prop="value" label="巡检结果" width="150px">
                </el-table-column>
                <el-table-column
                  prop="finishTime"
                  label="巡检完成时间"
                  width="150px"
                >
                </el-table-column>
              </el-table>
              <a
                slot="reference"
                @mouseenter="findInsAssetPlanItem(scope.row)"
                >{{ scope.row.totalCount }}</a
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="inspeopleName" label="巡检人"> </el-table-column>
        <el-table-column prop="companionName" label="陪同人"> </el-table-column>
        <el-table-column prop="finishTime" label="巡检时间"> </el-table-column>
        <el-table-column prop="type" label="类型" width="70" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="showType(scope.row)">{{
              scope.row.typename
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="never" label="频率" width="70" align="center">
        </el-table-column>
        <el-table-column prop="state" width="70" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="showState(scope.row)">{{
              scope.row.statename
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="faultcode"
          label="故障状态"
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.faultCode == null || scope.row.faultCode == ''"
              slot="reference"
              size="mini"
              type="success"
              >正常</el-tag
            >

            <el-popover v-else placement="top" trigger="hover">
              <p>&nbsp;&nbsp;故障编码</p>
              <div style="text-align: center; margin: 10">
                <el-link
                  v-for="(item, index) in scope.row.faultCodelist"
                  :key="index"
                  @click="viewFaultInfo(item)"
                  icon="el-icon-warning"
                  type="danger"
                  >{{ item }}&nbsp;
                </el-link>
                
              </div>
              <el-tag slot="reference" size="mini" type="danger">故障</el-tag>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="es-page-box">
        <es-pagination
          :data="devicePlanPageData"
          @change="
            (cpage) => {
              this.queryDetailObj.pageNum = cpage;
              this.loadDevicePlan();
            }
          "
        >
        </es-pagination>
      </div>
    </el-dialog>
    <!--播放视频-->
    <el-dialog
      :visible.sync="videoVisible"
      @closed="
        () => {
          $refs['videoplay'].pause();
        }
      "
      width="900px"
    >
      <video
        ref="videoplay"
        width="100%"
        height="600"
        controls
        :src="cvideo.url"
      ></video>

      <el-tag style="margin-top: 4px">
        <i class="el-icon-location"></i
        >{{ cvideo.location }} &nbsp;&nbsp;&nbsp;{{
          cvideo.up_time
        }}&nbsp;上传</el-tag
      >
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "insassetquery",
  props: ["funcs", "paramId"],
  data() {
    return {
      types: [],
      //label样式
      insItemList: [], //巡检项列表
      orgTree: [],
      selectorgId: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      detailVisible: false,
      assetItemInfo: {}, //线路信息

      //详情信息
      queryDetailObj: { pageNum: 1, pageSize: 20 ,orderBy: 'nextTime DESC'}, //查询条件
      selectLine: [],
      devicePlanPageData: [], // 设备巡检计划
      loading: false,
      loadingdevice: false,
      saving: false,

      PersonVisible: false,
      peoplesaving: false,
      areaImg: {},
      areaVideo: {},
      videoVisible: false,
      cvideo: {},
    };
  },
  methods: {
    //页面初始化
    init() {
      this.loadPlanLineList();
      this.loadTypeListAll();
      //弹出详情

      if (this.paramId != null) {
        this.detailVisible = false
        this.showDevicePlan({ 'assetName': this.paramId })
      }
    },
    //初始化设备类型下拉框
    loadTypeListAll() {
      this.$ajax
        .get("/base/assettype/list_all")
        .then((msg) => {
          this.types = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //从后台查询线路列表
    loadPlanLineList(orgIds) {
      this.selectorgId = orgIds;

      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }

      this.loading = true;
      this.$ajax
        .get("/buss/insAssetPlan/getAssetPlan", this.queryObj)
        .then((msg) => {
          this.pageData = msg;

          for (var i = 0; i < this.pageData.list.length; i++) {
            var faultCode = this.pageData.list[i].faultCode;
            var faultCodelist = [];
            if (faultCode != null) {
              faultCodelist = faultCode.split(",");
            }
            this.$set(this.pageData.list[i], "faultCodelist", faultCodelist);
          }

          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    findInsAssetPlanItem(row) {
      this.insItemList=[]
      this.$ajax
        .get("/buss/insAssetPlan/getAssetPlanItem", { planId: row.id })
        .then((msg) => {
          this.insItemList = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    initOrgTree(orgTree) {
      this.orgTree = orgTree;
    },
    showState(row) {
      if (row.state == 2) {
        if (row.type == 1) {
          let predictTime = this.$moment(row.beforeTime)
            .add(row.never, "days")
            .format("YYYY-MM-DD HH:mm:ss");
          console.log(row.beforeTime);
          console.log(row.finishTime);
          if (new Date(row.finishTime) > new Date(predictTime)) {
            row.statename = "逾期完成";
            return "warning";
          } else {
            row.statename = "完成";
            return "success";
          }
        } else if (row.type == 2) {
          let predictTime = this.$moment(row.beforeTime)
            .add(row.never, "months")
            .format("YYYY-MM-DD HH:mm:ss");
          console.log(predictTime);
          console.log(row.finishTime);
          if (new Date(row.finishTime) > new Date(predictTime)) {
            row.statename = "逾期完成";
            return "warning";
          } else {
            row.statename = "完成";
            return "success";
          }
        }
      }
    },
    showType(row) {
      if (row.type == 2) {
        row.typename = "月";
        return "warning";
      } else {
        row.typename = "天";
        return "warning";
      }
    },
    //查看详情信息
    showDevicePlan(row) {
      this.detailVisible = true;
      this.queryDetailObj.pageNum=1;
      this.assetItemInfo = JSON.parse(JSON.stringify(row));
      this.loadDevicePlan();
    },

    loadDevicePlan() {
      console.log(this.assetItemInfo.assetName);
      this.queryDetailObj.assetName = this.assetItemInfo.assetName;

      this.loadingdevice = true;
      this.$ajax
        .get("/buss/insAssetPlan/loadDeviceAssetPlan", this.queryDetailObj)
        .then((msg) => {
          this.devicePlanPageData = msg;
          for (var i = 0; i < this.devicePlanPageData.list.length; i++) {
            var faultCode = this.devicePlanPageData.list[i].faultCode;
            var faultCodelist = [];
            if (faultCode != null) {
              faultCodelist = faultCode.split(",");
            }
            this.$set(
              this.devicePlanPageData.list[i],
              "faultCodelist",
              faultCodelist
            );
          }
          this.loadingdevice = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loadingdevice = false;
        });
    },

    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },

    showImgs(row, i) {
      console.log(row);
      console.log(i);
      if (row.attachImgs == null) {
        return [];
      } else {
        let imgs = [];

        JSON.parse(row.attachImgs).forEach((e) => {
          imgs.push(
            this.$api +
              e.url +
              "&platform=web&token=" +
              this.$store.getUser().token
          );
        });

        if (imgs.length > 0) {
          this.areaImg[row.areaId + "_id"] = imgs;
        }
        console.log(row.attachImgs);
        return imgs;
      }
    },

    showVideo(row) {
      let v = null;
      0;
      if (row.attachVideo == null) {
        return null;
      } else {
        v = JSON.parse(row.attachVideo);
        v.url =
          this.$api + v.url + "&platform=web&token=" + this.$store.getUser().token;

        if (v != null) {
          this.areaVideo[row.areaId + "_id"] = v;
        }
        return v;
      }
    },
    play(areaId) {
      this.videoVisible = true;
      this.cvideo = this.areaVideo[areaId + "_id"];
    },
    viewFaultInfo(faultcode) {
      console.log(faultcode);
      this.$ajax
        .get("/buss/fault/load_detail", { code: faultcode })
        .then((msg) => {
          if (msg == null) {
            this.$message.error("没有找到故障数据");
            return;
          }
          if (this.$store.getUser().menus.indexOf("/fault/faultquery") >= 0) {
            let param = {
              id: 48,
              label: "故障查询",
              icon: "el-icon-yulanchakan",
              url: "/fault/faultquery",
            };
            if (msg != null) {
              param.paramId = msg.id;
            }
            this.$emit("add-tab", param);
          } else {
            this.$message.error("你没有故障查询权限");
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.viewVisible = false;
          this.viewLoading = false;
          this.loadingdevice = false;
        });
    },
  },
  mounted() {
    console.log(this.funcs);
    this.init();
  },
};
</script>
<style scoped></style>
